import { Entity } from '../../../types/apiTypes';
import { useScreenView } from '../../../utils/ScreenViewContext';
import { GreenGradientButton } from '../../../shared/Buttons';
import useFrontChat from '../../../hooks/useFrontChat';

interface PendingReviewProps {
  currStep: string;
  selectedRole: Entity;
  setStep: (step: string) => void;
}

/**
 * The end-of-signup "we're reviewing it" screen for vendors and partners.
 *
 * Carriers never land here: submitting Assets moves them to `pending_review` and `pre_active` in the
 * same request, and `AuthRouter` sends a pre-active user from `/signup` to the dashboard, where the
 * `pending_review` card in `OnboardingStepsWidget` is what they wait on.
 */
function PendingReview({ currStep, setStep }: PendingReviewProps) {
  // Initialize Front chat widget
  useFrontChat();

  const { screenView } = useScreenView();

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="w-full flex-1 overflow-y-auto lg:overflow-visible lg:py-10">
            <div className="flex w-full items-center justify-center px-6 pt-[5rem] lg:px-12">
              <div className={`flex w-[90%] flex-col items-center lg:w-[60%]`}>
                <div className="flex flex-col items-center">
                  <div className="flex flex-col items-center justify-center gap-y-[16px]">
                    <h1 className="mb-2 justify-center text-center text-[32px] font-semibold text-primary">
                      Application is Under Review
                    </h1>
                    <h2 className="text-center text-[20px] text-graysecondary">
                      Your information is currently being processed and
                      verified.
                    </h2>
                    <p className="text-center text-[16px] text-graysecondary">
                      You will receive a confirmation email once your
                      application is approved. As part of the onboarding
                      process.
                    </p>
                  </div>
                  <GreenGradientButton
                    addClass="mt-6"
                    onClick={() => {
                      window.location.href = 'https://tachusa.com';
                    }}
                  >
                    Got It!
                  </GreenGradientButton>
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  return <>{renderScreenView(screenView)}</>;
}

export default PendingReview;
